/* tslint:disable */
import {
  CompanyAccount,
  Banking
} from '../index';

declare var Object: any;
export interface PropertyBankInterface {
  "id"?: number;
  "property_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "bank_id"?: number;
  companyAccounts?: CompanyAccount;
  bankings?: Banking;
}

export class PropertyBank implements PropertyBankInterface {
  "id": number;
  "property_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "bank_id": number;
  companyAccounts: CompanyAccount;
  bankings: Banking;
  constructor(data?: PropertyBankInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyBank`.
   */
  public static getModelName() {
    return "PropertyBank";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyBank for dynamic purposes.
  **/
  public static factory(data: PropertyBankInterface): PropertyBank{
    return new PropertyBank(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyBank',
      plural: 'PropertyBanks',
      path: 'PropertyBanks',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "bank_id": {
          name: 'bank_id',
          type: 'number'
        },
      },
      relations: {
        companyAccounts: {
          name: 'companyAccounts',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        bankings: {
          name: 'bankings',
          type: 'Banking',
          model: 'Banking',
          relationType: 'belongsTo',
                  keyFrom: 'bank_id',
          keyTo: 'id'
        },
      }
    }
  }
}
